var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":"custom-action-controller"}},[_c('div',{ref:"testIfMobile",staticClass:"show-on-mobile"})])
}
var staticRenderFns = []

export { render, staticRenderFns }